import { onBeforeUnmount } from 'vue'

function useInterval() {
  let id = null

  const reset = () => {
    if (id) {
      clearInterval(id)
    }
  }

  const interval = (handler, time) => {
    reset()
    id = setInterval(handler, time)
  }

  onBeforeUnmount(reset)

  return { interval, reset }
}

export default useInterval
